import { clsx, type ClassValue } from 'clsx';
import slugify from 'slugify';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const generateShortId = (length = 7): string => {
  const chars =
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let shortId = '';
  for (let i = 0; i < length; i++) {
    shortId += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return shortId;
};

export const createSlug = (text: string, maxLength = 60) => {
  const baseSlug = slugify(text, {
    lower: true,
    strict: true,
    replacement: '_',
    trim: true,
  });

  if (baseSlug.length <= maxLength) return baseSlug;

  const parts = baseSlug.split('_');
  let shortened = '';

  for (const part of parts) {
    if ((shortened + (shortened ? '_' : '') + part).length > maxLength) break;
    shortened += (shortened ? '_' : '') + part;
  }

  return shortened;
};
